<div class="language-dropdown" [class.language-dropdown--inline]="inline">
  <app-button *ngIf="!inline" variant="outline" color="light" (click)="toggleDropdown()" [ariaLabel]="'app.language' | transloco">
    <span class="language-code">{{ currentLang.toUpperCase() }}</span>
    <i class="fas fa-chevron-down" aria-hidden="true"></i>
  </app-button>
  <div class="language-dropdown__menu" [class.active]="isOpen || inline">
    <div *ngFor="let lang of languages" class="language-dropdown__item" [class.active]="lang.code === currentLang" (click)="selectLanguage(lang.code)">
      <span class="language-code">{{ lang.code.toUpperCase() }}</span>
      <span class="language-name">{{ lang.name }}</span>
    </div>
  </div>
</div>
